import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { KEYS } from "../lib/storage-keys";

// Preferenze grafiche personali (dimensione testo): solo per questo browser,
// non per il business — persistita in localStorage e applicata come attributo
// su <html>, letto dalle regole CSS in index.css (nessun bisogno di toccare i
// singoli componenti). Il tema chiaro/scuro/sistema è gestito a parte da
// next-themes (vedi App.js).

const FONT_SIZE_KEY = KEYS.fontSize;

export const FONT_SIZES = [
  { value: "sm", label: "Piccolo" },
  { value: "md", label: "Medio" },
  { value: "lg", label: "Grande" },
];

const DisplaySettingsContext = createContext(null);

function readStored(key, fallback, allowed) {
  try {
    const value = window.localStorage.getItem(key);
    return allowed.includes(value) ? value : fallback;
  } catch {
    return fallback;
  }
}

export function DisplaySettingsProvider({ children }) {
  const [fontSize, setFontSizeState] = useState(() => readStored(FONT_SIZE_KEY, "md", FONT_SIZES.map(f => f.value)));

  // Applica solo l'attributo: la preferenza va in localStorage SOLO quando
  // l'utente la sceglie (P-22: prima veniva scritta al primo caricamento, anche
  // da anonimo e con il valore di default).
  useEffect(() => {
    document.documentElement.setAttribute("data-font-size", fontSize);
  }, [fontSize]);

  const setFontSize = useCallback(value => {
    if (!FONT_SIZES.some(f => f.value === value)) return;
    setFontSizeState(value);
    try { window.localStorage.setItem(FONT_SIZE_KEY, value); } catch { /* privacy mode: ignora */ }
  }, []);

  return (
    <DisplaySettingsContext.Provider value={{ fontSize, setFontSize }}>
      {children}
    </DisplaySettingsContext.Provider>
  );
}

export function useDisplaySettings() {
  const ctx = useContext(DisplaySettingsContext);
  if (!ctx) throw new Error("useDisplaySettings deve essere usato dentro DisplaySettingsProvider");
  return ctx;
}
